import { CALL_API } from "../../middleware/callApi"

const BASE_ACTION = "app/coronation"
const LOAD_REQUEST = `${BASE_ACTION}/load/request`
const LOAD_SUCCESS = `${BASE_ACTION}/load/success`
const LOAD_FAILURE = `${BASE_ACTION}/load/failure`

function loadData(ENDPOINT) {
	return {
		[CALL_API]: {
			endpoint: ENDPOINT,
			types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
		},
	}
}

export { LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE, loadData }
